import Modal from '../UI/Modal'
import { useT } from '../../hooks/useTranslation'

// Юридические дисклеймеры (Волна 0.3, 2026-08-31): Terms of Service + Privacy
// Policy (базовые), риск-дисклеймер, «это не финансовый совет» и возрастное
// ограничение 18+. Открывается из футера приложения (LegalFooter) — там же, где
// ссылки «Условия» и «Конфиденциальность». Язык — текущий язык приложения
// (useT читает его из стора), поэтому текст сам переключается RU/EN.
//
// Текст базовый и маркетингово-нейтральный; полноценные юридические документы
// владелец может заменить/расширить в translations.js, не трогая разметку.
function LegalBlock({ title, body, border }) {
  return (
    <div style={{
      background: 'rgba(255,255,255,0.04)',
      border: border || '1px solid rgba(255,255,255,0.06)',
      borderRadius: 14,
      padding: '14px 16px',
    }}>
      <div style={{ fontSize: 14, fontWeight: 700, color: '#fff', marginBottom: 8 }}>{title}</div>
      <div style={{ fontSize: 12.5, color: '#8E8E93', lineHeight: 1.6, whiteSpace: 'pre-line' }}>{body}</div>
    </div>
  )
}

export default function LegalModal({ onClose }) {
  const t = useT()

  return (
    <Modal title={t.legalTitle} onClose={onClose}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
        {/* Terms of Service */}
        <LegalBlock title={t.legalTosTitle} body={t.legalTosBody} />

        {/* Privacy Policy */}
        <LegalBlock title={t.legalPrivacyTitle} body={t.legalPrivacyBody} />

        {/* API Key Security (task.txt, 2026-09-16): успокаивающие пункты про
            ключи. Каждый факт подтверждён в коде: AES-256-GCM при сохранении,
            маска в UI, расшифровка только в памяти, админ не видит ключи. */}
        <LegalBlock title={t.legalSecurityTitle} body={t.legalSecurityBody} border="1px solid rgba(52,211,153,0.22)" />

        {/* Реферальная программа (п.4.4 ПЛАН_МАРКЕТИНГА, 2026-09-07): условия
            размещены здесь по просьбе владельца — в «Условиях» внизу мини-аппа.
            Кнопка «Условия программы» в реферальном блоке Настроек открывает это
            же окно. Текст — в translations.js (legalReferralTitle/Body). */}
        <LegalBlock title={t.legalReferralTitle} body={t.legalReferralBody} />

        {/* Риск-дисклеймер — тот же текст, что и на экране подписки */}
        <div style={{
          background: 'rgba(255,107,53,0.08)',
          border: '1px solid rgba(255,107,53,0.22)',
          borderRadius: 14,
          padding: '12px 14px',
          fontSize: 12.5, color: '#F59E0B', lineHeight: 1.55,
        }}>
          ⚠️ {t.legalRiskDisclaimer}
        </div>

        {/* Не финансовый совет */}
        <div style={{
          background: 'rgba(255,255,255,0.03)',
          border: '1px solid rgba(255,255,255,0.06)',
          borderRadius: 14,
          padding: '12px 14px',
          fontSize: 12.5, color: '#8E8E93', lineHeight: 1.55,
        }}>
          {t.legalNotFinancialAdvice}
        </div>

        {/* Возрастное ограничение */}
        <div style={{
          background: 'rgba(99,102,241,0.07)',
          border: '1px solid rgba(99,102,241,0.2)',
          borderRadius: 14,
          padding: '12px 14px',
          fontSize: 12.5, color: '#A5B4FC', lineHeight: 1.55,
        }}>
          🛡️ {t.legal18Plus}
        </div>
      </div>
    </Modal>
  )
}
